
import Vue from 'vue';
import Router from 'vue-router';
import Landing from '@/components/landing/Landing';
import Onboard from '@/components/onboard/Onboard';
import Login from '@/components/landing/Login';
import Org from '@/components/org/MobileOrg';
import Buildings from '@/components/org/WebOrg';
import Building from '@/components/building/Building';
import Floor from '@/components/floor/Floor';
import Heatmap from '@/components/floor/Heatmap';
import Card from '@/components/room/Card';
import Room from '@/components/room/Room';
import APIDocs from '@/components/api/APIDocs';
import Report from '@/components/report/Report';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: Landing
    },
    {
      path: '/onboard',
      name: 'Onboard',
      component: Onboard
    },
    {
      path: '/organization',
      name: 'Org',
      component: Org
    },
    {
      path: '/building/:id',
      name: 'Building',
      component: Building
    },
    {
      path: '/floor/:index',
      name: 'Floor',
      component: Floor
    },
    {
      path: '/heatmap/:index',
      name: 'Heatmap',
      component: Heatmap
    },
    {
      path: '/card/:index',
      name: 'Card',
      component: Card
    },
    {
      path: '/room/:index',
      name: 'Room',
      component: Room
    },
    {
      path:'/api',
      name: 'API',
      component: APIDocs
    },
    // {
    //   path: '/',
    //   name: 'Report',
    //   component: Report
    // }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js